import { Dialog, DialogContent, DialogActions, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import '../../../stylesheets/triagebot/Dialog.scss';

const GenericDialog = ({ open, onClose, title, content, actions }) => {
    return (
        <Dialog
            id='change-dialog'
            open={open}
            onClose={onClose}  PaperProps={{
              className:'Evisit-dialog'
            }}
        >
            <div id="dialog-title" className='popUp-Header'>
                <b className='headerTextCommon'>{title}</b>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: '#002677',
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </div>
            <DialogContent>
                <div className='evisit-PopupBody'>
                    {content}
                </div>
            </DialogContent>
            <DialogActions id="dialog-footer">
                {actions}
            </DialogActions>
        </Dialog>
    );
};

export default GenericDialog;